import React, { useEffect, useState } from "react";
import {
  getValueForInput,
  loadingStates,
  csvDownload,
  formatDate,
} from "../../utilities/utilities";
import { apiWrapWithErrorWithData } from "../../utilities/apiHelpers";
import {
  getAgreementsList,
  getAgreementTypesApi,
  getTotalAgreementsList,
  getAgreementsCsvDownload,
  getTotalAgreementsListType,
} from "../../utilities/apis/agreements";
import AgreementGraph from "./AgreementGraph";
import HamburgerMenuAgreements from "../HamburgerMenuAgreements";
import AgreementGraph1 from "./AgreementGraph1";
import AgreementAnalytics1 from "../../components/AgreementAnalytics/AgreementAnalytics1";

const statusOptions = [
  {
    label: "Pending with Company",
    value: "Pending with Company",
  },
  {
    label: "TP",
    value: "TP",
  },
];

const estampOption = [
  {
    label: "Yes",
    value: "Yes",
  },
  {
    label: "No",
    value: "No",
  },
];

const AgreementsAllStatus = () => {
  const currentYear = new Date().getFullYear();
  const [year, setYear] = useState(currentYear);
  const [configs, setConfigs] = useState({
    loading: loadingStates.LOADING,
    data: null,
  });
  const [filters, setFilter] = useState({
    typeOfAgreement: null,
    mapBusinessunit: null,
  });

  useEffect(() => {
    let cancelled = false;
    const fetchData = async () => {
      try {
        // sync creation of filter object
        const filtersForData = Object.fromEntries(
          Object.entries(filters).filter(([key, value]) => value !== null),
        );
        const response = await apiWrapWithErrorWithData(
          getTotalAgreementsList({ filterOptions: filtersForData, year: year }),
        );
        const response2 = await apiWrapWithErrorWithData(
          getTotalAgreementsListType({ filterOptions: filtersForData, year }),
        );
        console.log("API response from getTotalAgreementsList: ", response);
        console.log(
          "API response from getTotalAgreementsListType: ",
          response2,
        );

        // if (response.success && response2.success) {
        //   // create a small summary to avoid freezing the UI
        // const dataToSet = {
        //   success: !!response.success,
        //   agreementByMonth:
        //     response.agreementByMonth && response.agreementByMonth,
        //   agreementByYear:
        //     response.agreementByYear && response.agreementByYear,
        // agreementsLocationWise:
        //   response.agreementsLocationWise &&
        //   response.agreementsLocationWise,
        // agreementTypeWise:
        //   response2.agreementTypeWise && response2.agreementTypeWise,

        // };
        //   console.log("Data to be set in state: ", dataToSet);
        //   setConfigs({
        //     loading: loadingStates.NO_ACTIVE_REQUEST,
        //     data: dataToSet,
        //   });
        //   if (cancelled) return;
        // }
        if (response.success && response2.success) {
          const normalizedAgreementByMonth = (
            response.agreementByMonth2 || []
          ).map((item) => ({
            month: item.month,
            _avg: {
              noOfCompletionDays: item._avg_noOfCompletionDays,
            },
            _count: {
              id: item._count_id,
            },
          }));

          const normalizedAgreementByYear = (
            response.agreementByYear2 || []
          ).map((item) => ({
            year: Number(item.contract_year),
            _avg: {
              noOfCompletionDays: item.avg_noOfCompletionDays,
            },
            _count: {
              id: item.count_id,
            },
          }));

          const dataToSet = {
            success: !!response.success,
            agreementByMonth: normalizedAgreementByMonth,
            agreementByYear: normalizedAgreementByYear,
            agreementsLocationWise:
              response.agreementsLocationWise &&
              response.agreementsLocationWise,
            agreementTypeWise:
              response2.agreementTypeWise && response2.agreementTypeWise,
          };

          if (cancelled) return;

          setConfigs({
            loading: loadingStates.NO_ACTIVE_REQUEST,
            data: dataToSet,
          });
        }
      } catch (error) {
        console.error("Error fetching data: ", error);
      }
    };
    const wrappedFetch = async () => {
      try {
        await fetchData();
      } catch (e) {
        console.log("error: ", e);
        /* handled inside fetchData */
      }
    };
    wrappedFetch();
    return () => {
      cancelled = true;
    };
  }, [filters, year]);
  console.log("configs: ", configs);
  console.log("filters: ", filters);

  if (configs.loading === loadingStates.LOADING) {
    return (
      <div className="flex justify-center items-center h-[60vh]">
        <div className="animate-pulse text-slate-500">Loading Analytics...</div>
      </div>
    );
  }

  return (
    <div className="p-5 min-h-screen">
      <div className="dashboard-header analytics-header">
        <div className="dashboard-header-left">
          <h1 className="dashboard-heading">All Contracts</h1>
          <p className="dashboard-subtitle">Overview of all contracts</p>
        </div>

        <div className="dashboard-header-right">
          <HamburgerMenuAgreements />
        </div>
      </div>

      <div className="grid grid-cols-1 gap-8">
        <AgreementAnalytics1
          filter={filters}
          setFilter={setFilter}
          configs={configs}
        />

        <div className="grid grid-cols-2 gap-6">
          <AgreementGraph setYear={setYear} year={year} configs={configs} />
          <AgreementGraph1 configs={configs} />
        </div>
      </div>
    </div>
  );
};

export default AgreementsAllStatus;
